import React, { memo, useMemo } from 'react';
import { patternPreviewData } from '@/audio/patternPreview';

export const PatternClipPreview = memo(function PatternClipPreview({ clip }) {
  const data = useMemo(() => patternPreviewData(clip), [clip]);
  if (!data) return null;
  return <svg data-testid={`pattern-preview-${clip.id}`} aria-hidden="true" viewBox="0 0 100 28" preserveAspectRatio="none" style={{ position: 'absolute', inset: '17px 5px 3px', width: 'calc(100% - 10px)', height: 28, opacity: .75, pointerEvents: 'none' }}>
    {data.type === 'notes' ? data.notes.map((note, index) => <rect key={index} x={note.x * 100} y={note.y * 28} width={Math.max(.8, note.width * 100)} height="2.8" rx=".8" fill="rgba(255,255,255,.86)" opacity={.45 + note.velocity * .5} />)
      : data.hits.map((hit, index) => <line key={index} x1={hit.x * 100} x2={hit.x * 100} y1={Math.max(1, hit.y * 27 - 2.4)} y2={Math.min(27, hit.y * 27 + 2.4)} stroke="rgba(255,255,255,.9)" strokeWidth={hit.velocity >= .7 ? 1.8 : 1} />)}
  </svg>;
});

export default PatternClipPreview;
